import dynamic from 'next/dynamic';

import clsx from 'clsx';

import type { TextBlockFragment } from '@hultafors/hultaforsgroup/types';

import { Button } from '../button/button';
import { Markdown } from '../markdown/markdown';
import styles from './text-block.module.scss';

const HTag = dynamic(() =>
  import('@hultafors/shared/components').then((mod) => mod.HTag),
);

// ctaButtons is required in the GraphQL schema, even though it is optional in Dato.
interface TextBlockProps extends Partial<TextBlockFragment> {
  fullwidth?: boolean;
}

export const TextBlock: React.FC<TextBlockProps> = ({
  ctaButtons = [],
  fullwidth,
  header,
  introText,
  smallHeader,
  text,
}) => {
  return (
    <section
      className={clsx(!fullwidth && 'content-container', styles['wrapper'])}
    >
      {header && (
        <HTag
          className={styles['title']}
          styleType={smallHeader ? 'h5' : 'h4'}
          type="h2"
        >
          {header}
        </HTag>
      )}
      {introText && (
        <HTag className={styles['intro']} styleType="p2-paragraph" type="h3">
          {introText}
        </HTag>
      )}
      {text && (
        <div className={styles['text']}>
          <Markdown>{text}</Markdown>
        </div>
      )}
      {ctaButtons && ctaButtons.length > 0 && (
        <div className={styles['button-container']}>
          {ctaButtons.map((button) => (
            <Button
              className={styles['button']}
              key={`button-${button.id}`}
              label={button.text}
              textColor="var(--button-text-color)"
              to={button.url}
              variant={button.variant}
            />
          ))}
        </div>
      )}
    </section>
  );
};
